import type { ApprovalRequest } from '@/lib/types';
import { BucketShell } from './_BucketShell';

export interface MixedPiBookContextViewProps {
  req: ApprovalRequest;
}

export function MixedPiBookContextView({ req }: MixedPiBookContextViewProps) {
  return (
    <BucketShell req={req}>
      <section className="rounded-lg border border-orange-300 bg-orange-50 p-16">
        <p className="text-xs font-semibold uppercase tracking-wide text-orange-800">
          Goods posting context issue
        </p>
        <p className="mt-4 text-sm text-neutral-700">
          Selected GRNs cross purchase-invoice books or posting contexts. This is a
          goods-invoice context mismatch, not a service invoice or no-GRN case.
        </p>
        <p className="mt-12 text-sm text-neutral-600">
          Pick GRNs from a single compatible purchase-invoice book/context before
          approving the goods posting.
        </p>
      </section>
    </BucketShell>
  );
}
